import script from "./FileInputCapture.vue?vue&type=script&lang=ts&setup=true"
export * from "./FileInputCapture.vue?vue&type=script&lang=ts&setup=true"

import "./FileInputCapture.vue?vue&type=style&index=0&id=1268eb79&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1268eb79"]])

export default __exports__